<template>
  <div class="bg-fa of">
    <section id="index" class="container">
      <header class="comm-title">
        <h2 class="fl tac">
          <span class="c-333">物品列表</span>
        </h2>
      </header>
      <form @submit.prevent="searchThings">
        <div class="mb-3">
          <label for="itemId" class="form-label">物品ID</label>
          <input type="number" class="form-control" id="itemId" v-model="searchParams.itemId">
        </div>
        <div class="mb-3">
          <label for="name" class="form-label">物品名称</label>
          <input type="text" class="form-control" id="name" v-model="searchParams.name">
        </div>
        <div class="mb-3">
          <label for="classname" class="form-label">物品类别</label>
          <input type="text" class="form-control" id="classname" v-model="searchParams.classname">
        </div>
        <button type="submit" class="btn btn-primary">查询</button>
      </form>
      <el-table :data="list" border style="width: 100%">
        <el-table-column prop="itemId" label="物品ID" width="100"></el-table-column>
        <el-table-column prop="name" label="物品名称"></el-table-column>
        <el-table-column prop="classname" label="物品类别"></el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </section>
  </div>
</template>

<script>
import thingApi from '@/api/xuanchuan'; // 导入 xuanchuan.js

export default {
  data() {
    return {
      list: [], // 物品列表
      searchParams: {
        itemId: '',
        name: '',
        classname: ''
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0 // 总记录数
    };
  },

  created() {
    this.searchThings();
  },

  methods: {
    // 查询物品列表
    searchThings() {
      thingApi.searchThings1(this.currentPage, this.pageSize, this.searchParams)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.total; // 更新总记录数
        })
        .catch((error) => {
          console.error('查询物品失败:', error);
        });
    },

    // 每页显示条数变化时触发
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.searchThings();
    },

    // 当前页码变化时触发
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.searchThings();
    }
  }
};
</script>

<style scoped>
.bg-fa {
  background-color: #f9f9f9;
}

.of {
  overflow: hidden;
}

.form-label {
  font-weight: bold;
}

.form-control {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-primary:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}
</style>